export const dashboardFormFieldHook = 'dashboard-form-field';
export const DashboardToggleSwitchWrapperHook =
  'dashboard-toggle-switch-wrapper';
export const DashboardToggleSwitchHook = 'dashboard-toggle-switch';
